import React, { Component } from 'react'

import CarouselItem from './CarouselItem'
import OfferCarousel from 'components/Common/OfferCarousel'
import type { CarouselProps } from 'nuka-carousel'
import CarouselArrows from './CarouselArrows'

const carouselSettings: Partial<CarouselProps> = {
  showDots: false,
  arrows: <CarouselArrows />,
}

interface Props {
  offers: Array<App.Offer | App.OfferSummary>
  onSlideChange: (offerId: string) => void
  ref?: React.Ref<any>
}

interface State {
  selectedItem: null | string
}

class Carousel extends Component<React.PropsWithChildren<Props>, State> {
  state: State = {
    selectedItem: null,
  }

  carouselEl = React.createRef<OfferCarousel>()

  onSlideChange = (offerId: string) => {
    this.setState({
      selectedItem: offerId,
    }, () => this.props.onSlideChange(offerId))
  }

  goToSlideForOffer = (offerId: string): void => {
    if (!this.state.selectedItem) {
      this.setState({
        selectedItem: offerId,
      })
    }
    this.carouselEl.current?.goToSlideForOffer(offerId)
  }

  render() {
    return <OfferCarousel
      carouselSettings={carouselSettings}
      ref={this.carouselEl}
      offers={this.props.offers}
      onSlideChange={this.onSlideChange}
    >
      {this.props.offers.map(offer => <CarouselItem
        offer={offer}
        selected={this.state.selectedItem === offer.id}
        onProductClick={this.onSlideChange}
        key={offer.id}
      />)}
    </OfferCarousel>
  }
}

export default Carousel
